// extracted by mini-css-extract-plugin
export default {"customIcon":"MenuTabBar_customIcon__LR2PJ","menuTabBar":"MenuTabBar_menuTabBar__ud2Ft","menuItem":"MenuTabBar_menuItem__abJYU","active":"MenuTabBar_active__vs2v1"};